import axios from '../../utils/axios';

export default function deleteLGBillTarget(adminId, targetId, data) {
    return (
        axios.post(`/admin/${adminId}/lGBillTarget/${targetId}/delete`,  data )
    )
}
